import React, { useState,useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import UpdateSize from "./UpdateSize";
import Delete from "../Include/Delete"
import { DELETE_SIZE } from "../../Schema/Size";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";

export default function SizeAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  // console.log("editData::",editData)

  const [deleteSize] = useMutation(DELETE_SIZE, {
    onCompleted: ({ deleteSize }) => {
      // console.log("deleteSize::", deleteSize);
      setLoading(false);
      if (deleteSize?.status === true) {
        setAlert(true, "success", deleteSize?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteSize?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteSize({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
          onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateSize
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      {/* <DeleteUnit
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      /> */}
      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"Size"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
